import React, { useContext } from "react";
import RSelect, { Props } from "react-select";
import makeAnimated from "react-select/animated";

import { ThemeContext } from "../../../theme/provider/theme-provider";

const animatedComponents: any = makeAnimated();

export type SelectOption = {
  label: string;
  value: string;
};

export const Select = ({ css, ...props }: Props<SelectOption>) => {
  const {
    theme: { colors },
  } = useContext(ThemeContext);
  return (
    <RSelect<SelectOption>
      {...props}
      blurInputOnSelect={false}
      tabSelectsValue={false}
      styles={{
        option: (styles, { isFocused }) => ({
          ...styles,
          color: isFocused ? colors.white : styles.color,
          "&:active": {
            color: colors.white,
          },
        }),
        multiValue: (styles) => ({
          ...styles,
          backgroundColor: colors.primary,
        }),
        multiValueLabel: (styles) => ({ ...styles, color: colors.white }),
        multiValueRemove: (styles) => ({
          ...styles,
          backgroundColor: colors.primary,
          color: colors.white,
          ":hover": { backgroundColor: colors.primaryDark },
        }),
      }}
      theme={(selectTheme) => ({
        ...selectTheme,
        colors: {
          ...selectTheme.colors,
          primary: colors.primaryDark,
          primary25: colors.primaryLight,
          primary75: colors.primary,
          primary50: colors.primaryLight,
        },
      })}
      components={animatedComponents}
    />
  );
};
